import { getData } from "api/dataVisualisation/client";
import { Region } from "components/dataVisualization/restorationZone/RegionFilter";
import { DataDownloadFormat } from "models/dataDownload/dataDownloadFormat";
import {
  DataDownloadModel,
  JsonDataDownloadModel,
} from "models/dataDownload/dataDownloadModel";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { RestorationZoneDemandForecastModel } from "models/restorationZone/restorationZoneDemandForecast";

import { mapRegionFilterToRequestParamValue } from "./utils";

export const getRestorationZoneDemandForecastData = async (
  dateFilter: DateFilterModel,
  regionFilter: Region,
  format?: DataDownloadFormat,
  gspGroupId?: string
): Promise<DataDownloadModel<RestorationZoneDemandForecastModel>> => {
  const { data } = await getData(
    "/datasets/RZDF",
    {
      SubmissionDateTimeFrom: dateFilter.normalisedStartDate.toISOString(),
      SubmissionDateTimeTo: dateFilter.normalisedEndDate.toISOString(),
      Region: mapRegionFilterToRequestParamValue(regionFilter),
      GspGroupId: gspGroupId,
    },
    format
  );
  return data;
};

export const getRestorationZoneDemandForecastJsonData = (
  dateFilter: DateFilterModel,
  regionFilter: Region
): Promise<JsonDataDownloadModel<RestorationZoneDemandForecastModel>> =>
  getRestorationZoneDemandForecastData(
    dateFilter,
    regionFilter,
    DataDownloadFormat.Json
  ) as Promise<JsonDataDownloadModel<RestorationZoneDemandForecastModel>>;
